import { useCallback } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';

import TrashCan from '@gef-ui/material-icons/TrashCan';

import taskForwarding from 'features/views/taskForwarding';
import { equalOrThreeDashes, fromIsoDate, getCodelistPropById } from 'utils';
import { getClientName } from 'utils/client';

export const TasksTableRow = ({ taskId, showDeleteButton, taskTypesCodelist, taskSubtypesCodelist }) => {
	const dispatch = useDispatch();
	const task = useSelector((state) => taskForwarding.selectors.getTaskById(taskId, state));

	const handleRemoveTask = useCallback(() => {
		dispatch(taskForwarding.actions.removeTask(taskId));
	}, [dispatch, taskId]);

	const { policy = {}, client = {} } = task;

	const clientName = getClientName(client);
	const taskType = getCodelistPropById(task.taskTypeId, taskTypesCodelist, 'description');
	const taskSubtype = getCodelistPropById(task.taskSubtypeId, taskSubtypesCodelist, 'description');

	return (
		<TableRow>
			<TableCell>{equalOrThreeDashes(taskId)}</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(taskType)} </div>
				<div> {equalOrThreeDashes(taskSubtype)}</div>
			</TableCell>
			<TableCell>{equalOrThreeDashes(fromIsoDate(task?.deadlineDate))}</TableCell>
			<TableCell>{equalOrThreeDashes(policy?.policyNo)}</TableCell>
			<TableCell>{equalOrThreeDashes(clientName)}</TableCell>
			{showDeleteButton && (
				<TableCell>
					<TrashCan sx={{ color: 'primary.main', cursor: 'pointer' }} onClick={handleRemoveTask} />
				</TableCell>
			)}
		</TableRow>
	);
};

TasksTableRow.propTypes = {
	showDeleteButton: PropTypes.bool,
	taskId: PropTypes.number,
	taskSubtypesCodelist: PropTypes.array,
	taskTypesCodelist: PropTypes.array,
};

export default TasksTableRow;
